import {
  Cancel,
  CheckCircle,
  CheckCircleOutline,
  HighlightOff,
} from '@mui/icons-material';
import { IconButton, Stack } from '@mui/material';
import { OrderStatus, OrderTypes } from '../../../common/enums/enums';
import useStatusByService from '../hooks/useStatusByService';

export default function ActionsByService({ service, orderType }) {
  const { markServiceAsApproved, markServiceAsDeclined, status } =
    useStatusByService(service);

  const iconByStatus = {
    approved: (status === OrderStatus.approved && <CheckCircle />) || (
      <CheckCircleOutline />
    ),
    cancelled: (status === OrderStatus.declined && <Cancel />) || (
      <HighlightOff />
    ),
  };

  const disabledButtons = orderType === OrderTypes.WORK_ORDER;

  return (
    <Stack direction="row" gap={{ xs: 1, md: 2 }}>
      <IconButton
        size="small"
        color={status === OrderStatus.declined ? 'error' : 'default'}
        sx={{
          '&:hover': {
            backgroundColor: 'rgba(255, 80, 95, 0.08)',
          },
          visibility: (disabledButtons && 'hidden') || 'visible',
        }}
        onClick={() => markServiceAsDeclined(service.vendorOrderServiceId)}
      >
        {iconByStatus.cancelled}
      </IconButton>
      <IconButton
        size="small"
        color={status === OrderStatus.approved ? 'success' : 'default'}
        hidden={disabledButtons}
        sx={{
          '&:hover': {
            backgroundColor: 'rgba(76, 175, 80, 0.08)',
          },
          visibility: (disabledButtons && 'hidden') || 'visible',
        }}
        onClick={() => markServiceAsApproved(service.vendorOrderServiceId)}
      >
        {iconByStatus.approved}
      </IconButton>
    </Stack>
  );
}
